import $ from 'jquery';

import config from './globals/config';

export default function (videoControls, player) {
  videoControls.find('.pause').on('click', function () {
    player.pause();
  });

  videoControls.find('.play').on('click', function () {
    player.play();
  });

  videoControls.find('.fullscreen').on('click', function (e) {
    e.preventDefault();
    player.requestFullscreen();
  });

  videoControls.find('.mute').on('click', function () {
    config.isMute = true;
    player.muted(true);
    $(this).addClass('hide');
    $(this).parent().find('.unmute').removeClass('hide');
  });

  videoControls.find('.unmute').on('click', function () {
    player.volume(1);
    player.muted(false);
    $(this).addClass('hide');
    $(this).parent().find('.mute').removeClass('hide');
    config.isMute = false;
  });

  videoControls.find('.share').on('click', function (e) {
    e.preventDefault();
    // update the share social information
    // do this here because set-trailer-info can be called before player is initialized
    let trailerLink = $('#' + player.id_).parent().find(' #seeMoreLink');

    if (trailerLink.length) {
      player.social({
        'url': trailerLink.attr('href'),
      });
    }

    $('#' + player.id_ + ' .vjs-share-control').click();
  });
}
